var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pt-3 pb-3"},[_c('i',{staticClass:"ti ti-2x ti-fw ti-spin ti-refresh mb-2"}),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
export { render, staticRenderFns }